import {
  createSlice,
} from '@reduxjs/toolkit';
import { setBaseState } from '../../../store/utils/setStoreState';

const passPortWidgetsSlice = createSlice({
  name: 'passPortWidgets',
  initialState: {
    passportWidgetsJsReady: false,
    renderShippingSuccess: false,
  },
  reducers: {
    setPassportWidgetsJsReady: setBaseState('passportWidgetsJsReady'),
    setRenderShippingSuccess: setBaseState('renderShippingSuccess'),
  },
});

export const {
  setPassportWidgetsJsReady, setRenderShippingSuccess,
} = passPortWidgetsSlice.actions;

export default passPortWidgetsSlice.reducer;
